import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { urls } from './../../../../environments/environment';

@Injectable()
export class AdminService {

  constructor(
    private http: HttpClient
  ) { }

  getDashboard(beginDate, finalDate, contaId) {
    return this.http
      .get(urls.apiBase + '/Admin/ObterDashboard?dataInicio=' + beginDate + '&dataFim=' + finalDate + '&contaId=' + contaId);
  }

  getLancamentosFuturos(contaId) {
    return this.http
      .get(urls.apiBase + '/Admin/ObterLancamentosFuturos?contaId=' + contaId);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/admin/admin.service.ts